import useTranslation from 'next-translate/useTranslation';

import { getCdnUrl } from '~/domains/assets/utils/getCdnUrl';

import { PromoModalShell, type PromoModalSection } from './PromoModalShell';

export interface SplitEntryPromoModalProps {
  isOpen?: boolean;
  isClosing?: boolean;
  onClose?: () => void;
}

const SECTION_KEYS = ['enterContest', 'inviteGroup', 'chooseCaptain', 'acceptInvites', 'win'] as const;

export function SplitEntryPromoModal(props: SplitEntryPromoModalProps) {
  const { t } = useTranslation('contest');

  const sections: PromoModalSection[] = SECTION_KEYS.map((key) => ({
    title: t(`detail.promoCallouts.splitEntry.modal.sections.${key}.title`),
    text: t(`detail.promoCallouts.splitEntry.modal.sections.${key}.text`),
  }));

  return (
    <PromoModalShell
      {...props}
      icon={getCdnUrl('/images/promo/contest-detail-split-entry-logo.png')}
      title={t('detail.promoCallouts.splitEntry.modal.title')}
      availableLabel={t('detail.promoCallouts.splitEntry.available')}
      body={sections}
      note={t('detail.promoCallouts.splitEntry.modal.note')}
      dataTestId="contest-detail-split-entry-modal"
      hasSteps
    />
  );
}

export default SplitEntryPromoModal;
